<template>
  <div>
    <div class="enneagram-display" v-if="data">
      <v-row justify="space-around" v-if="data.primary || data.selected">
        <v-col class="image-container">
          <img
            v-if="data.selected"
            :src="`assessments/enneagram/type_${data.selected.number}.svg`"
          />
          <img
            v-else
            :src="`assessments/enneagram/type_${data.primary.number}.svg`"
          />
        </v-col>
      </v-row>
      <v-row justify="space-around" v-else>
        <v-col class="image-container">
          <img src="assessments/enneagram/no_type.svg" />
        </v-col>
      </v-row>

      <div class="visible-message" v-if="!data.visible">
        This data is hidden from the mentee. Edit results to make visible.
      </div>
      <span v-if="data.selected">
        <v-card elevation="0" class="enneagram-card" v-if="data.selected">
          <v-card-text>
            <div>Enneagram Type</div>
            <p class="display-1">
              {{ data.selected.number }}. {{ data.selected.title }}
            </p>
            <v-simple-table>
              <tbody>
                <tr>
                  <th>Description</th>
                  <td>
                    {{ data.selected.description }}
                  </td>
                </tr>
                <tr>
                  <th>Motivation</th>
                  <td>{{ data.selected.motivation }}</td>
                </tr>
                <tr>
                  <th>At Work</th>
                  <td>{{ data.selected.at_work }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <div class="mt-4">
              <span class="overline">the types as tested: </span>
              <span v-if="data.primary"
                >{{ data.primary.number }} {{ data.primary.title }},
              </span>
              <span v-if="data.secondary"
                >{{ data.secondary.number }} {{ data.secondary.title }},
              </span>
              <span v-if="data.tertiary"
                >{{ data.tertiary.number }} {{ data.tertiary.title }}</span
              >
            </div>
          </v-card-text>
        </v-card>
      </span>
      <span v-else>
        <v-card elevation="0" class="enneagram-card" v-if="data.primary">
          <v-card-text>
            <div>Highest Score</div>
            <p class="display-1">
              {{ data.primary.number }}. {{ data.primary.title }}
            </p>
            <v-simple-table>
              <tbody>
                <tr>
                  <th>Description</th>
                  <td>
                    {{ data.primary.description }}
                  </td>
                </tr>
                <tr>
                  <th>Motivation</th>
                  <td>{{ data.primary.motivation }}</td>
                </tr>
                <tr>
                  <th>At Work</th>
                  <td>{{ data.primary.at_work }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>

        <v-card elevation="0" class="enneagram-card" v-if="data.secondary">
          <v-card-text>
            <div>Second Highest Score</div>
            <p class="display-1">
              {{ data.secondary.number }}. {{ data.secondary.title }}
            </p>
            <v-simple-table>
              <tbody>
                <tr>
                  <th>Description</th>
                  <td>
                    {{ data.secondary.description }}
                  </td>
                </tr>
                <tr>
                  <th>Motivation</th>
                  <td>{{ data.secondary.motivation }}</td>
                </tr>
                <tr>
                  <th>At Work</th>
                  <td>{{ data.secondary.at_work }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>

        <v-card elevation="0" class="enneagram-card" v-if="data.tertiary">
          <v-card-text>
            <div>Third Highest Score</div>
            <p class="display-1">
              {{ data.tertiary.number }}. {{ data.tertiary.title }}
            </p>
            <v-simple-table>
              <tbody>
                <tr>
                  <th>Description</th>
                  <td>
                    {{ data.tertiary.description }}
                  </td>
                </tr>
                <tr>
                  <th>Motivation</th>
                  <td>{{ data.tertiary.motivation }}</td>
                </tr>
                <tr>
                  <th>At Work</th>
                  <td>{{ data.tertiary.at_work }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </span>
    </div>
    <div v-else class="enneagram-display">
      <v-row justify="space-around">
        <v-col class="image-container">
          <img src="assessments/enneagram/no_type.svg" />
        </v-col>
      </v-row>
    </div>
    <div>
      <span class="overline mr-3">Enneagram Results Document</span>
      <a
        id="js-enneagram-doc-link"
        v-if="data && data.document_name"
        :href="data.document_url"
        target="_blank"
        download=""
        >{{ data.document_name }}</a
      >
    </div>
    <v-btn
      v-if="!isMember"
      class="ma-4 js-updaters-toggle-button"
      small
      fab
      dark
      color="secondary"
      @click="showUpdaters = !showUpdaters"
    >
      <v-icon dark>mdi-pencil</v-icon>
    </v-btn>

    <v-sheet elevation="4" class="ma-4 pa-6" v-if="showUpdaters">
      <enneagram-add
        :userId="userId"
        :primaryType="
          data && data.primary ? data.primary.number.toString() : ''
        "
        :secondaryType="
          data && data.secondary ? data.secondary.number.toString() : ''
        "
        :tertiaryType="
          data && data.tertiary ? data.tertiary.number.toString() : ''
        "
        :selectedType="
          data && data.selected ? data.selected.number.toString() : ''
        "
        :visible="data && data.visible"
      ></enneagram-add>
    </v-sheet>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import EnneagramAdd from "@/components/assessments/EnneagramAdd"
import { AssessmentsAPI } from "@/lib/api"

export default {
  mixins: [eventMixin],
  components: {
    EnneagramAdd
  },
  data: function() {
    return {
      showUpdaters: false
    }
  },
  props: {
    userId: { type: Number },
    data: { type: Object, default: () => {} },
    isMember: { type: Boolean, default: false }
  },
  created() {
    console.log(this.data)
    this.addListener(
      "enneagram_result:add",
      ({
        userId,
        primaryType,
        secondaryType,
        tertiaryType,
        selectedType,
        visible
      }) => {
        this.fireEvent("enneagram_result:add2", {
          userId: userId,
          primaryType: primaryType,
          secondaryType: secondaryType,
          tertiaryType: tertiaryType,
          selectedType: selectedType,
          visible: visible
        })
      }
    )
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.image-container {
  text-align: center;
}

.enneagram-display {
  color: $dark-grey;
}

img {
  width: 100%;
}

.enneagram-card {
  margin: 0px 0px 10px 0px;
  padding: 0px;
  border: 1px solid $light-grey;
}

.display-1 {
  color: $dark-blue;
}

.visible-message {
  color: $white;
  background-color: $orange;
  border-radius: 5px;
  font-size: 2em;
  padding: 5px;
  text-align: center;
  width: 100%;
  margin-bottom: 10px;
  @media (max-width: 1200px) {
    font-size: 1.2em;
  }
}
</style>
